import React from 'react';
import Loadable from 'react-loadable';

import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';

let Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('../wp_page').default;
}

export default function(store) {
  const routeConfig = {
    path:
      '/apply/:slug(most-innovative-companies|brands-that-matter|best-workplaces-for-innovators)',
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk() {
      return import(/* webpackChunkName: "applyWpPage" */ '../wp_page').then(
        resp => {
          Component = resp.default;
          routeConfig.loadData = Component.loadData(store);
          return Component;
        }
      );
    },
    chunk: 'applyWpPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="video-page">
          <article className="video-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
